import { userConstants } from '../constants'
import { userRequests } from '../../services'
import { handleErrorMessage } from '../../utils'

export const userActions = {}

userActions.RegisterChangePassword = (data) => {
    return dispatch => {
        dispatch(request())
        userRequests.RegisterChangePassword(data)
            .then(
                registerCPassData => dispatch(success(registerCPassData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: userConstants.REGISTER_CHANGEPASS_REQUEST }
    }

    function success(registerCPassData) {
        return { type: userConstants.REGISTER_CHANGEPASS_SUCCESS, registerCPassData }
    }

    function failure(error) {
        return { type: userConstants.REGISTER_CHANGEPASS_FAILURE, error }
    }
}

userActions.RecoverChangePassword = (data) => {
    return dispatch => {
        dispatch(request())
        userRequests.RecoverChangePassword(data)
            .then(
                registerCPassData => dispatch(success(registerCPassData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: userConstants.RECOVER_PASSWORD_REQUEST }
    }

    function success(registerCPassData) {
        return { type: userConstants.RECOVER_PASSWORD_SUCCESS, registerCPassData }
    }

    function failure(error) {
        return { type: userConstants.RECOVER_PASSWORD_FAILURE, error }
    }
}